import type { CityConfig } from "../city-template/types";

export const southBendConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "South Bend",
  state: "Indiana",
  stateAbbr: "IN",
  slug: "south-bend",
  route: "/cities/south-bend",
  title: "Emergency Passport South Bend, IN — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in South Bend, Indiana — as fast as 24 hours. Fast passport renewal and new passport applications for South Bend, Mishawaka, Granger, Notre Dame, and all St. Joseph County residents. A+ BBB rated courier service serving the University of Notre Dame community.",
  h1: "Emergency & Expedited Passport Services in South Bend, IN",
  heroSubtitle: "South Bend travelers — from University of Notre Dame students and faculty heading abroad to St. Joseph County families planning international vacations to Michiana business professionals — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated registered courier with direct access to the Chicago Passport Agency, serving the entire Notre Dame community and North Central Indiana.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=South%20Bend%20Indiana%20cityscape%20with%20the%20iconic%20University%20of%20Notre%20Dame%20Golden%20Dome%20and%20Hesburgh%20Library%20reflecting%20in%20the%20St%20Joseph%20River%20on%20a%20beautiful%20autumn%20day%2C%20vibrant%20college%20town%20atmosphere%20with%20tree%20lined%20streets%20and%20collegiate%20gothic%20architecture%2C%20northern%20Indiana%20charm%2C%20warm%20golden%20afternoon%20sunlight%2C%20professional%20city%20photography%2C%20no%20text%20or%20people%2C%20editorial%20style%20urban%20photography&width=1800&height=700&seq=south-bend-in-hero-001&orientation=landscape",
  heroImageAlt: "South Bend Indiana with Notre Dame Golden Dome and St. Joseph River views",
  geoPosition: "41.6764;-86.2520",
  geoPlacename: "South Bend, Indiana",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St Suite 380, Chicago IL 60604",
    distance: "Approximately 90 miles, 1.5 hours via I-90",
  },
  nearbyCitiesZips: [
    { name: "South Bend", zips: "46601, 46613, 46614, 46615, 46616, 46617, 46619, 46628, 46635, 46637" },
    { name: "Mishawaka", zips: "46544, 46545, 46546" },
    { name: "Granger", zips: "46530" },
    { name: "Notre Dame", zips: "46556" },
    { name: "Osceola", zips: "46561" },
    { name: "Elkhart", zips: "46514, 46516, 46517" },
    { name: "Niles", zips: "49120, 49121" },
    { name: "Bremen", zips: "46506" },
    { name: "Lakeville", zips: "46536" },
    { name: "New Carlisle", zips: "46552" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Registered courier to Chicago Passport Agency — serving South Bend, Notre Dame, and all St. Joseph County" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting for the Michiana and Notre Dame community" },
    { icon: "ri-building-line", title: "Notre Dame Hub", desc: "Serving ND students, faculty, staff, alumni, and St. Joseph County families" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels from any UPS or FedEx near downtown South Bend or ND campus" },
  ],
  internalLinks: [
    { name: "Expedited passport in Mishawaka, IN", route: "/cities/mishawaka" },
    { name: "Emergency passport help in Elkhart, IN", route: "/cities/elkhart" },
    { name: "Urgent passport services in Fort Wayne, IN", route: "/fort-wayne" },
    { name: "Indiana passport services overview", route: "/states/indiana" },
  ],
  fpcOfficeAddress: "230 S Dearborn St Suite 380, Chicago IL 60604",
  fpcOfficeNote: "Fast Passport Center serves South Bend, Indiana via secure registered courier to the Chicago Passport Agency (230 S Dearborn St Suite 380, Chicago IL 60604). Approximately 90 miles — about 1.5 hours via I-90. We handle the drive so South Bend residents, Notre Dame students and faculty, and St. Joseph County families never need to make the trip to Chicago themselves.",
  fpcOfficeDistance: "Serving South Bend, Mishawaka, Granger, Notre Dame, Osceola, Niles MI, Elkhart, and all St. Joseph County and the greater Michiana region",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout South Bend and St. Joseph County. From the Notre Dame campus and downtown South Bend to Mishawaka, Granger, and the Michigan border region — we serve all of Michiana's largest city with courier access to the Chicago Passport Agency.",
  nearbyCitiesIntro: "We serve South Bend and all nearby communities including Mishawaka, Granger, Notre Dame, Osceola, Elkhart, Niles (MI), Bremen, Lakeville, and New Carlisle. We also serve all of St. Joseph County, the Notre Dame community, and the greater Michiana region including Michigan border communities.",
  howItWorksIntro: "Most South Bend travelers — especially ND students and faculty — complete everything online and ship documents via overnight courier from any UPS or FedEx near campus or downtown South Bend. Our registered couriers handle the Chicago Passport Agency delivery so you can focus on your travel plans.",
  mistakesIntro: "South Bend is home to the University of Notre Dame, one of the nation's leading universities with extensive international programs. Here are the most common passport mistakes we see from St. Joseph County and Notre Dame travelers.",
  testimonialsIntro: "South Bend travelers — from Notre Dame students studying abroad to St. Joseph County families to Michiana business professionals — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in South Bend, IN? Here are the most common ones we hear from Notre Dame and St. Joseph County travelers.",
  statePageRoute: "/states/indiana",
  statePageName: "Indiana",
  dmvWebsite: "https://www.in.gov/bmv",
  dmvLabel: "Indiana BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "No Indianapolis drive required — ship from South Bend", "Perfect for ND study abroad, faculty research, and family vacations", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Faster than self-service", "Good for planned study abroad and family travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive to Chicago Passport Agency (~2.5 hours each way)", "Limited appointments for non-emergency travelers"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For South Bend travelers with immediate departure needs — as fast as 24 hours. Ideal for Notre Dame students with unexpected study abroad deadlines or last-minute international conference travel.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency — courier handles the 2.5-hour drive", "Notre Dame student and faculty travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for South Bend adults with a passport issued within the last 15 years. Skip the post office appointment — ideal for ND faculty, alumni, and St. Joseph County professionals.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your St. Joseph County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for ND students, St. Joseph County residents, and new citizens in the South Bend area.",
      bullets: ["Acceptance facility scheduling near campus", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for South Bend residents — whether lost on campus, during a move, or while preparing for travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for South Bend and St. Joseph County families traveling internationally with kids.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for South Bend and St. Joseph County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport South Bend IN", description: "Urgent passport processing for South Bend Indiana travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal South Bend IN", description: "Fast passport renewal for South Bend Indiana residents with a previously-issued passport." },
    { name: "First-Time Passport South Bend IN", description: "New passport application services for South Bend Indiana residents and Notre Dame students." },
    { name: "Child Passport South Bend IN", description: "Minor passport services for South Bend Indiana families with children under 16." },
  ],
  testimonials: [
    {
      name: "Michael O.",
      location: "South Bend, IN — Notre Dame Campus",
      rating: 5,
      text: "Study abroad program in Rome starting in 8 days — realized my passport had less than 3 months validity. Fast Passport Center got me renewed in 3 days. Shipped from the UPS Store near campus and everything worked out. A lifesaver for ND students!",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Professor Kathleen M.",
      location: "South Bend, IN — Near ND Campus",
      rating: 5,
      text: "Research symposium in Tokyo with 10 days notice. My passport needed renewal for the Japanese 6-month validity rule. Fast Passport Center expedited everything — had my new passport in 4 days without ever driving to Indianapolis. Outstanding for academic travelers.",
      service: "Expedited Passport Renewal",
    },
    {
      name: "Daniel R.",
      location: "South Bend, IN — Near Howard Park",
      rating: 5,
      text: "Family trip to Ireland and my three kids needed first-time passports. The South Bend Post Office was booked for weeks. Fast Passport Center processed all three applications in 5 days. Incredible service for Michiana families.",
      service: "Family Passport Bundle",
    },
    {
      name: "Rebecca L.",
      location: "Granger, IN",
      rating: 5,
      text: "Lost my passport somewhere during a move from Chicago to Granger. Had a flight to London in 7 days. Fast Passport Center replaced it in 48 hours. I never even had to leave St. Joseph County. The courier service to Indianapolis was a game-changer.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "south-bend-in-1",
      name: "South Bend Post Office — Main",
      type: "USPS Passport Acceptance Facility",
      address: "424 S Michigan St",
      city: "South Bend",
      state: "IN",
      zip: "46601",
      phone: "(574) 282-8511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown South Bend, near the St. Joseph River",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary St. Joseph County acceptance facility in downtown South Bend. Appointments required — book 2–3 weeks ahead during ND academic year. Extremely busy during study abroad season (September–October and February–March) and football season.",
      icon: "ri-mail-line",
    },
    {
      id: "south-bend-in-2",
      name: "St. Joseph County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "101 S Main St",
      city: "South Bend",
      state: "IN",
      zip: "46601",
      phone: "(574) 235-9635",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown South Bend, St. Joseph County Courthouse",
      website: "https://www.sjcindiana.com/",
      websiteLabel: "St. Joseph County",
      notes: "County clerk passport acceptance at the St. Joseph County Courthouse. Extended morning hours (opens at 8AM). Excellent alternative to post office facilities — often less crowded than the main post office during ND peak periods.",
      icon: "ri-government-line",
    },
    {
      id: "south-bend-in-3",
      name: "Mishawaka Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "111 E 3rd St",
      city: "Mishawaka",
      state: "IN",
      zip: "46544",
      phone: "(574) 255-5545",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 5 miles east of South Bend, downtown Mishawaka",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Adjacent acceptance facility in Mishawaka. Often has better appointment availability than the South Bend main post office during ND football and graduation seasons.",
      icon: "ri-mail-line",
    },
    {
      id: "south-bend-in-4",
      name: "Granger Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "12460 Adams Rd",
      city: "Granger",
      state: "IN",
      zip: "46530",
      phone: "(574) 271-0088",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 10 miles northeast of South Bend, in Granger",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Northeast St. Joseph County facility. Often has the best appointment availability in the South Bend metro area during peak travel seasons. Good option for eastern South Bend and Granger residents.",
      icon: "ri-mail-line",
    },
    {
      id: "south-bend-in-5",
      name: "Elkhart Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "601 S Main St",
      city: "Elkhart",
      state: "IN",
      zip: "46516",
      phone: "(574) 293-0411",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 15 miles east of South Bend, downtown Elkhart",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Elkhart County facility. Good alternative for eastern St. Joseph County residents near the Elkhart County border. Call ahead for appointment availability.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 90-mile, 1.5-hour drive to Chicago via I-90", fpc: "No — ship from South Bend, courier handles it" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Notre Dame Study Abroad", agency: "No special support for academics", fpc: "Experienced with ND study abroad and faculty travel" },
    { feature: "Photo & Document Help", agency: "No guidance provided", fpc: "Yes — full document review included" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "ND students often discover passport issues right before study abroad deadlines. Routine processing takes 8–11 weeks. The South Bend Post Office is completely overwhelmed during ND study abroad application seasons (March for fall programs, October for spring). Start expedited service at least 6 weeks before travel.",
    },
    {
      icon: "ri-road-map-line",
      title: "Underestimating the Indianapolis Drive",
      description: "At 2.5 hours down US-31 (each way), visiting the Chicago Passport Agency consumes an entire day. Factor in Indiana construction season (March–November), winter weather, and rush hour through Kokomo and the northern Indy suburbs — a 5-hour round trip for a 15-minute appointment is simply not practical.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Campus-area photo services and ND student center photo booths sometimes produce photos that fail Department of State standards. Photos must be exactly 2x2 inches on a white background — no filters, no smiling with teeth showing, no glasses. The State Department rejects photos for the smallest deviations.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "First-time applicants — especially ND students applying for their first passport — often miss signatures or use the wrong form. DS-11 requires in-person execution at an acceptance facility. DS-82 can be mailed for most renewal situations for adults who already hold a passport.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking 6-Month Passport Validity",
      description: "Many countries — especially across Europe and Asia — require 6 months of passport validity beyond your stay. ND students heading to semester-long study abroad programs in London, Rome, Dublin, or Beijing frequently discover this requirement only weeks before departure.",
    },
    {
      icon: "ri-calendar-line",
      title: "Not Accounting for ND Academic Calendar",
      description: "Notre Dame's academic calendar creates predictable passport demand spikes: study abroad deadlines (March and October), graduation (May — families traveling internationally after ceremonies), and football season (September–November, when visiting alumni discover passport issues). Book services well in advance of these windows.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in South Bend or on the ND campus." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at the UPS Store near campus or any FedEx in South Bend." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for ND or St. Joseph County documentation errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier delivers to the Chicago Passport Agency — no need to make the 2.5-hour drive." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your South Bend address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in South Bend, IN?", a: "Fast Passport Center offers emergency passport processing in South Bend, Indiana in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (230 S Dearborn St Suite 380, Chicago IL 60604) — no need to make the 2.5-hour drive yourself. This is especially valuable for Notre Dame students and faculty with urgent academic travel deadlines." },
    { q: "Does South Bend have its own passport agency?", a: "No — South Bend does not have a regional passport agency. The nearest is the Chicago Passport Agency, approximately 145 miles south (about 2.5 hours via US-31). Fast Passport Center's courier service means South Bend residents, ND students, and St. Joseph County families never need to make the long trip to Indianapolis themselves." },
    { q: "Can Notre Dame international students get passport help in South Bend?", a: "Fast Passport Center specializes in U.S. passport services for U.S. citizens. International ND students should contact their home country's embassy or consulate for passport services. We can help ND faculty, staff, and U.S. citizen students with American passport needs." },
    { q: "What airport do South Bend travelers use?", a: "South Bend International Airport (SBN) is located right in South Bend with connecting flights to major hubs. For direct international flights, Chicago O'Hare (ORD) is about 1.5 hours west via I-80/I-90, and Detroit Metro (DTW) is about 2.5 hours east via I-94. Many ND travelers use ORD for international departures." },
    { q: "How much does an expedited passport cost in South Bend?", a: "Government fees are fixed: $130 for a first-time adult passport or $130 + $60 expedite fee for a renewed adult passport book. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline and ND travel requirements." },
    { q: "Where can I get passport photos in South Bend?", a: "Walgreens (multiple locations including 2002 S Bend Ave and 3915 Lincolnway W), CVS (4601 W Western Ave), the UPS Store (1233 N Eddy St near ND campus), and ND's Hammes Bookstore (seasonally) all offer passport photos. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve ND faculty traveling for research?", a: "Yes. We serve all University of Notre Dame faculty, staff, and researchers in South Bend. We understand academic travel deadlines — international conferences, research collaborations, field work, and visiting scholar programs — and coordinate expedited services to match your specific academic schedule." },
    { q: "What about Mishawaka, Granger, or Niles MI residents?", a: "Absolutely. Fast Passport Center serves all of St. Joseph County and the greater Michiana region including South Bend, Mishawaka, Granger, Osceola, and Niles (Michigan). Our courier service works the same way for everyone — ship from your local UPS or FedEx, and we handle the Indianapolis delivery." },
  ],
  photoLocations: [
    { name: "Walgreens — South Bend (S Bend Ave)", address: "2002 S Bend Ave, South Bend, IN 46637", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS — South Bend", address: "4601 W Western Ave, South Bend, IN 46619", hours: "Mon–Sun: 8AM–9PM" },
    { name: "UPS Store — South Bend (ND Area)", address: "1233 N Eddy St, South Bend, IN 46617", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "Walgreens — South Bend (Lincolnway)", address: "3915 Lincolnway W, South Bend, IN 46628", hours: "Mon–Sun: 7AM–10PM" },
  ],
  dmvLocations: [
    { name: "Indiana BMV — South Bend", address: "219 Lucas Dr, South Bend, IN 46601", hours: "Mon–Fri: 8:30AM–6:00PM", note: "St. Joseph County BMV branch on Lucas Drive near downtown. Driver's licenses and REAL ID processing. Online reservations strongly recommended — this is the primary branch for South Bend, ND campus area, and western St. Joseph County.", featured: true },
    { name: "Indiana BMV — Mishawaka", address: "2424 Miracle Ln, Mishawaka, IN 46545", hours: "Mon–Fri: 8:30AM–6:00PM", note: "Serves Mishawaka, Granger, and eastern St. Joseph County. Good alternative when South Bend branch is busy. REAL ID processing available near Grape Road.", featured: false },
  ],
  airports: [
    {
      code: "SBN",
      name: "South Bend International Airport",
      distance: "Approximately 10 minutes from downtown South Bend — about 4 miles northwest",
      address: "4477 Progress Dr, South Bend, IN 46628",
      note: "Local airport for South Bend and the Michiana region. Connecting flights to major hubs (Chicago, Detroit, Atlanta, Minneapolis, Charlotte). Convenient for domestic connections — international travelers typically connect through ORD, DTW, or ATL. Features a quick and efficient terminal with minimal wait times.",
      flightUrl: "https://flysbn.com/",
      flightLabel: "SBN Flight Info",
      featured: true,
    },
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "Approximately 1.5 hours west of South Bend via I-80/I-90 — about 95 miles",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Primary international airport for Notre Dame travelers and Michiana residents. One of the world's busiest airports with direct flights to destinations across six continents. Major hub for United and American Airlines. ND international students and faculty frequently use ORD for overseas travel.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    { label: "St. Joseph County: Birth & Death Certificates", url: "https://www.in.gov/health/vital-records/", icon: "ri-file-text-line", description: "Indiana Department of Health Vital Records — order birth and death certificates for St. Joseph County and all Indiana counties" },
    { label: "St. Joseph County Clerk: Marriage Licenses", url: "https://www.sjcindiana.com/", icon: "ri-heart-line", description: "St. Joseph County Clerk — marriage license records for South Bend and St. Joseph County" },
    { label: "St. Joseph County: Divorce Decrees", url: "https://www.sjcindiana.com/", icon: "ri-file-list-3-line", description: "St. Joseph County Clerk of Courts — divorce decree records for South Bend and St. Joseph County" },
    { label: "VitalChek Nationwide Service", url: "https://www.vitalchek.com/", icon: "ri-global-line", description: "Order Indiana vital records online through VitalChek for delivery to your South Bend address" },
  ],
};